import { DatePicker } from 'antd';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import locale from 'antd/lib/date-picker/locale/de_DE';
import { Moment } from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { IconPaths } from 'src/icons';
import { ApplicationState } from 'src/store';
import { createSeason, getSeasons } from 'src/store/season/actions';
import { SeasonCreate } from 'src/store/season/types';

const { RangePicker } = DatePicker;

interface Props {
  createSeason: typeof createSeason;
  loading: boolean;
}

interface State {
  selected?: number;
  title: string;
  daterange: {
    startdate?: Moment;
    enddate?: Moment;
  };
}

const initValues = {
  title: '',
  daterange: {
    startdate: undefined,
    enddate: undefined
  }
};

type AllProps = Props & RouteComponentProps<any>;

class SeasonManagement extends React.Component<AllProps, State> {
  sectionTitle: string;

  constructor(props: AllProps) {
    super(props);

    this.state = initValues;
  }

  componentDidMount() {
    this.sectionTitle = this.props.match.params.sectionTitle;
  }

  render() {
    const { loading } = this.props;

    return (
      <div className="container">
        <div className="col-lg-8 centered">
          <h2 style={{ textAlign: 'left' }}>Saison erstellen</h2>
          <LoadingSpinner pending={loading} />
          <table className="styledTable">
            <thead>
              <tr>
                <th />
                <th>Titel</th>
                <th>Datumsbereich</th>
                <th />
              </tr>
            </thead>
            <tbody>{this.seasonEditView()}</tbody>
          </table>
        </div>
      </div>
    );
  }

  seasonEditView = () => {
    return (
      <tr>
        <td />
        <td>
          <input
            autoComplete="off"
            type="text"
            value={this.state.title}
            name="title"
            onChange={this.onChangeSeason}
          />
        </td>
        <td>
          <RangePicker
            format="DD.MM.YYYY"
            locale={locale}
            onChange={(dates: RangePickerValue) => {
              this.onChangeDateRange(dates[0], dates[1]);
            }}
          />
        </td>
        <td>
          <button onClick={this.onSave} className="noStyle">
            <img src={IconPaths['save-icon']} title="Speichern" height="20px" width="auto" />
          </button>
        </td>
      </tr>
    );
  };

  onChangeDateRange = (startdate?: Moment, enddate?: Moment) => {
    if (startdate && enddate) {
      this.setState(prevState => {
        return {
          ...prevState,
          daterange: {
            ...prevState.daterange,
            startdate,
            enddate
          }
        };
      });
    }
  };

  onChangeSeason = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const name = e.target.name;

    this.setState(prevState => {
      return {
        ...prevState,
        [name]: inputValue
      };
    });
  };

  onSave = () => {
    if (this.state.daterange && this.state.daterange.startdate && this.state.daterange.enddate) {
      this.props.createSeason(
        {
          title: this.state.title,
          startdate: this.state.daterange.startdate,
          enddate: this.state.daterange.enddate,
          sectionTitle: this.sectionTitle
        },
        this.sectionTitle,
        () => {
          this.setState(initValues);
        }
      );
    }
  };
}

const mapStateToProps = ({ season }: ApplicationState) => ({
  seasonData: season.data,
  loading: season.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  getSeasons: (sectionTitle: string) => dispatch(getSeasons(sectionTitle)),
  createSeason: (season: SeasonCreate, sectionTitle: string, successCB: () => any) =>
    dispatch(createSeason(season, sectionTitle, successCB))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeasonManagement);



// WEBPACK FOOTER //
// ./src/pages/Management/SeasonManagement/CreateSeason.tsx